var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['number-badge', {'disabled': !_vm.number}],on:{"click":function($event){return _vm.$emit('click',$event)}}},[_c('div',{staticClass:"number",class:{translate: _vm.translate}},[_vm._v(_vm._s(_vm.number))])])
}
var staticRenderFns = []

export { render, staticRenderFns }